module.exports = __webpack_public_path__ + "static/media/unicorn.4c486932.svg";